import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import Roadmap from './RoadMapPage.jsx'
import EventsPage from './EventsPage.jsx'
import ContactPage from './ContactPage.jsx'
import FAQPage from './FAQPage.jsx'
import PrivacyPolicyPage from './PrivacyPolicyPage.jsx'
import CookiePolicyPage from './CookiePolicyPage.jsx'
import ScrollToHash from './components/ScrollToHash.jsx'
import CookieConsent from './components/CookieConsent.jsx'
import { LanguageProvider } from './i18n'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/FAQ" element={<FAQPage />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/camps" element={<EventsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </LanguageProvider>
  </StrictMode>
)